var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show_filters_button"},[_c('div',{staticClass:"show_filters_button_label"},[_vm._v("Фильтры")]),_c('IconBase',{attrs:{"width":"24","height":"24","icon-name":"options","view-box":"0 0 24 24","no-divider":true}},[_c('IconOptions')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }